export default __webpack_public_path__ + "static/media/profile-default.3da56567.svg";